import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/motoristas/editar/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  }
});
